import { createFileRoute } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { InvestorHomeRedirect } from '../../../../components/investor-home-redirect'
import { InvestorDashboardPage } from '../../../../features/legacy-investor/investor-dashboard-page'

// Dashboard is gone; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/')({
  component: () => (
    <AssistantSwitch assistant={<InvestorHomeRedirect />} classic={<InvestorDashboardPage />} />
  ),
})
